import {
  useDatasetsSyncingToAnalytics,
  UseDatasetsSyncingToAnalyticsParams,
} from '@monorepo/shared/hooks/analyticsSync/useDatasetsSyncingToAnalytics';
import { DatasetType } from 'mapistry-shared';
import { useMemo } from 'react';

export const useWorkflowsSyncingToAnalytics = ({
  config,
  organizationId,
}: UseDatasetsSyncingToAnalyticsParams) => {
  const { datasetsSyncingToAnalytics, ...queryInfo } =
    useDatasetsSyncingToAnalytics({ organizationId, config });
  const workflowIdsSyncingToAnalytics = useMemo(
    () =>
      datasetsSyncingToAnalytics
        ?.filter((dataset) => dataset.type === DatasetType.WORKFLOW)
        .map((dataset) => dataset.originId),
    [datasetsSyncingToAnalytics],
  );
  return {
    workflowIdsSyncingToAnalytics,
    ...queryInfo,
  };
};
